// @flow
import React from 'react';

import { ESTIMATE_COMMIT_DETAILS_CONFIG_MAP } from '../../configuration/estimate-commit-details';
import { CUSTOM_DISCOUNTS_ENABLED_BACKEND_NAME } from '../../constants';
import { BooleanSelectField } from '../../formik-utils/FormFields';

export const CustomDiscountsEnabledContainer = () => {
  const customDiscountsEnabledConfig = ESTIMATE_COMMIT_DETAILS_CONFIG_MAP.get(
    CUSTOM_DISCOUNTS_ENABLED_BACKEND_NAME
  );

  return (
    <BooleanSelectField
      fieldDisplayName={customDiscountsEnabledConfig.displayName}
      fieldName={customDiscountsEnabledConfig.backendFieldName}
    />
  );
};
